import React, { Component } from 'react';
import TextInput from 'screens/components/basic/TextInput';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Paper, IconButton, TextField
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from 'screens/components/basic/Button';
import "./DeliveryZoneStyle.css";
import { connect } from 'react-redux';
import { formInput } from 'actions/FormActions';
import ConfirmationSection from './SubComponents/ConfirmationSection';
import { showSnackbar } from 'actions/CommonActions';
import { createDeliveryZone, deleteDeliveryZone, getDeliveryZone, updateDeliveryZone } from 'actions/EntityActions';
import { selectDeliveryZone } from 'selectors/entitySelector';

class DeliveryZone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingRow: null,
      editingColumn: null,
      isUpdate: false,
      isDelete: false,
      editingDeliveryZoneId: null,
      editingDeliveryZoneCost: null,
      editingDeliveryZoneCity: null
    };
    this.setTableRef = element => {
      this.tableRef = element;
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutsideTable);
    document.addEventListener('touchstart', this.handleClickOutsideTable);
  }

  componentDidUpdate(prevProps) {
    const { deliveryZoneDeleteSuccessTime, showSnackbar, getDeliveryZone, deliveryZoneUpdateSuccessTime, branchId, deliveryZoneDeleteFailmsg, deliveryZoneUpdateFailmsg, deliveryZoneDeleteFailTime, deliveryZoneUpdateFailTime, deliveryZoneCreateSuccessTime, deliveryZoneCreateFailTime } = this.props;

    if ((prevProps.deliveryZoneCreateSuccessTime === null && deliveryZoneCreateSuccessTime !== null)
      || prevProps.deliveryZoneCreateSuccessTime !== deliveryZoneCreateSuccessTime) {
      getDeliveryZone(this.props.branchId);
      this.handleCancelButton();
    }
    if ((prevProps.deliveryZoneCreateFailTime == null && deliveryZoneCreateFailTime != null)
      || prevProps.deliveryZoneCreateFailTime !== deliveryZoneCreateFailTime) {
      showSnackbar("Delivery Zone City Creation Failed!");
    }

    if ((prevProps.deliveryZoneDeleteSuccessTime === null && deliveryZoneDeleteSuccessTime !== null)
      || prevProps.deliveryZoneDeleteSuccessTime !== deliveryZoneDeleteSuccessTime) {
      getDeliveryZone(branchId);
      this.handleCancelButton();
    }

    if ((prevProps.deliveryZoneUpdateSuccessTime === null && deliveryZoneUpdateSuccessTime !== null)
      || prevProps.deliveryZoneUpdateSuccessTime !== deliveryZoneUpdateSuccessTime) {
      getDeliveryZone(branchId);
      this.handleCancelButton();
    }

    if ((prevProps.deliveryZoneDeleteFailTime == null && deliveryZoneDeleteFailTime != null)
      || prevProps.deliveryZoneDeleteFailTime !== deliveryZoneDeleteFailTime) {
      showSnackbar(deliveryZoneDeleteFailmsg);
    }

    if ((prevProps.deliveryZoneUpdateFailTime == null && deliveryZoneUpdateFailTime != null)
      || prevProps.deliveryZoneUpdateFailTime !== deliveryZoneUpdateFailTime) {
      showSnackbar(deliveryZoneUpdateFailmsg);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideTable);
    document.removeEventListener('touchstart', this.handleClickOutsideTable);
  }

  handleSaveDeliveryZone = () => {
    const model = this.props.deliveryZoneModel;

    for (const key in model) {
      const value = model[key];
      if (value === undefined || value === null || value === '' || value === 0 || Number.isNaN(value)) {
        this.props.showSnackbar("Both fields have to be filled!");
        return;
      }
    }
    this.props.createDeliveryZone(model);
  };

  deliveryCostOnChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    this.props.formInput(value, name);
  }

  handleClickOutsideTable = (event) => {
    if (this.tableRef && !this.tableRef.contains(event.target)) {
      this.setState({ editingRow: null, editingColumn: null, editingDeliveryZoneId: null, editingDeliveryZoneCost: null, editingDeliveryZoneCity: null, isUpdate: false, isDelete: false });
      this.props.formInput("", "deliveryZoneNewCost");
    }
  };

  handleCellClick = (rowNumber, columnId) => {
      console.log(rowNumber, columnId);
    this.setState({ editingRow: rowNumber, editingColumn: columnId });
  };

  handleUpdateButtonClick = (deliveryZoneId, city, cost) => {
    if (!this.props.deliveryZoneNewCost) {
      this.props.showSnackbar("Enter New Cost Before Click Update Button");
      return;
    }

    this.setState({ editingDeliveryZoneId: deliveryZoneId, editingDeliveryZoneCost: cost, editingDeliveryZoneCity: city, isUpdate: true, isDelete: false });

  };

  handleDeleteButtonClick = (deliveryZoneId, city) => {
    this.setState({ editingDeliveryZoneId: deliveryZoneId, editingDeliveryZoneCity: city, isDelete: true, isUpdate: false });
  };

  handleCancelButton = () => {
    this.setState({ editingRow: null, editingColumn: null, editingdeliveryZoneId: null, editingDeliveryZoneCost: null, editingDeliveryZoneCity: null, isUpdate: false, isDelete: false, DeliveryZoneFixedDeliveryCost: "", deliveryZoneNewCost: "" });
    this.props.formInput("", "deliveryZoneNewCost");
    this.props.formInput("", "DeliveryZoneDeliveryCity");
    this.props.formInput("", "DeliveryZoneFixedDeliveryCost");
  };

  handleConfirmDeleteDeliveryZone = () => {
    this.props.deleteDeliveryZone(this.state.editingDeliveryZoneId);
  };

  handleConfirmUpdateDeliveryZone = () => {
    this.props.updateDeliveryZone({
      Id: this.state.editingDeliveryZoneId,
      Cost: this.props.deliveryZoneNewCost
    });
  };

  render() {
    const { deliveryZoneList, deliveryZoneNewCost } = this.props;
    const textUpdate = `Are you sure to Update city ${this.state.editingDeliveryZoneCity} from $${this.state.editingDeliveryZoneCost} to $${deliveryZoneNewCost}?`;
    const textDelete = `Are you sure to remove city ${this.state.editingDeliveryZoneCity} from the list?`;
    return (
      <div>
        <div className="row">
          <span className="pl-1"><i>Set up individual delivery fees based on each city. If this setting is turned on, the city field will be replaced with a dropdown selection of supported delivery zones.</i></span><br /><br />
          <section>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-1">
              <span style={{ color: `grey` }}>Delivery City</span><br />
              <TextInput
                name={`DeliveryZoneDeliveryCity`}
                fullWidth={true}
                hintText="Delivery Zone (City Name)"
                maxLength={50}
                className="delivery-zone-textInput"
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-1">
              <span style={{ color: `grey` }}>Fixed Delivery Fee</span><br />
              <TextField
                name={`DeliveryZoneFixedDeliveryCost`}
                type={'number'}
                fullWidth={true}
                onChange={(e) => this.deliveryCostOnChange(e)}
                hintText="Delivery Fee"
                maxLength={50}
                className="delivery-zone-textInput"
                value={this.state.DeliveryZoneFixedDeliveryCost || ""}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-1">
              <Button
                type="RaisedButton"
                className="btnNewBrandPOS"
                name={"Add"}
                label={"Add"}
                onTouchTap={this.handleSaveDeliveryZone}
              />
            </div>
          </section>
        </div>
        {deliveryZoneList && deliveryZoneList.length > 0 ?
          !this.state.isDelete && !this.state.isUpdate ?
            <section className="delivery-zone-table-container" ref={this.setTableRef}>
              <Table showRowHover={false} selectable={false} onCellClick={this.handleCellClick}>
                <TableHead displaySelectAll={false} adjustForCheckbox={false}>
                  <TableRow>
                    <TableCell className="delivery-zone-table-header-city">City</TableCell>
                    <TableCell className="delivery-zone-table-header-fixed-delivery-fee">Fixed Delivery Fee</TableCell>
                    <TableCell className="delivery-zone-table-header-action">Edit / Delete</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody displayRowCheckbox={false}>
                  {deliveryZoneList.map((list, i) => (
                    <TableRow key={i}>
                      <TableCell className="delivery-zone-table-cell-city">{list.city}</TableCell>
                      <TableCell className="delivery-zone-table-cell-fixed-delivery-fee"  onClick={() => this.handleCellClick(i, 2)}>
                        {this.state.editingRow === i && this.state.editingColumn === 2
                          ? <TextField
                            name={`deliveryZoneNewCost`}
                            type={'number'}
                            fullWidth={true}
                            onChange={(e) => this.deliveryCostOnChange(e)}
                            placeholder="New Cost"
                            maxLength={50}
                            className="delivery-zone-textInput"
                          />
                          : `$${list.cost}`
                        }
                      </TableCell>
                      <TableCell className="delivery-zone-table-cell-action">
                        <div className="delivery-zone-table-button-container">
                          <IconButton className="delivery-zone-table-update" onClick={() => this.handleUpdateButtonClick(list.id, list.city, list.cost)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton className="delivery-zone-table-delete" onClick={() => this.handleDeleteButtonClick(list.id, list.city)}>
                            <DeleteIcon />
                          </IconButton>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </section> :
            this.state.isUpdate ? <ConfirmationSection text={textUpdate} onCancel={this.handleCancelButton} onConfirm={this.handleConfirmUpdateDeliveryZone} />
              :
              this.state.isDelete ? <ConfirmationSection text={textDelete} onCancel={this.handleCancelButton} onConfirm={this.handleConfirmDeleteDeliveryZone} />
                : ""
          : ""}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    deliveryZoneList: state.form.deliveryZoneList || [],
    deliveryZoneNewCost: state.form.deliveryZoneNewCost || "",
    deliveryZoneCreateSuccessTime: state.form.deliveryZoneCreateSuccessTime || null,
    deliveryZoneCreateFailTime: state.form.deliveryZoneCreateFailTime || null,
    deliveryZoneDeleteSuccessTime: state.form.deliveryZoneDeleteSuccessTime,
    deliveryZoneUpdateSuccessTime: state.form.deliveryZoneUpdateSuccessTime,
    deliveryZoneDeleteFailTime: state.form.deliveryZoneDeleteFailTime,
    deliveryZoneDeleteFailmsg: state.form.deliveryZoneDeleteFailmsg,
    deliveryZoneUpdateFailTime: state.form.deliveryZoneUpdateFailTime,
    deliveryZoneUpdateFailmsg: state.form.deliveryZoneUpdateFailmsg,
    deliveryZoneModel: selectDeliveryZone(state),
    deliveryZoneFixedDeliveryCost: state.form.DeliveryZoneFixedDeliveryCost
  };
};

function mapDispatchToProps(dispatch) {
  return {
    formInput: (value, name) => dispatch(formInput(value, name)),
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    deleteDeliveryZone: (message) => dispatch(deleteDeliveryZone(message)),
    updateDeliveryZone: (message) => dispatch(updateDeliveryZone(message)),
    getDeliveryZone: (model) => dispatch(getDeliveryZone(model)),
    createDeliveryZone: (model) => dispatch(createDeliveryZone(model))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryZone);
